import { z } from 'zod';
export const LoginRequest = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export const ActivateRequest = z.object({
    token: z.string().min(1),
    password: z.string().min(8).max(200),
});
export const ResetRequest = z.object({
    email: z.string().email(),
});
export const ResetConfirm = z.object({
    token: z.string().min(1),
    password: z.string().min(8).max(200),
});
export const VerifyEmailRequest = z.object({
    code: z.string().regex(/^\d{6}$/),
});
/** genadmin — доступ как у admin, но только просмотр (без записи) и без уведомлений. */
export const Role = z.enum(['admin', 'operator', 'senior_manager', 'manager', 'client', 'genadmin']);
export const MeResponse = z.object({
    id: z.string(),
    email: z.string(),
    fullName: z.string(),
    role: Role,
    roles: z.array(Role),
    emailVerified: z.boolean(),
});
//# sourceMappingURL=auth.js.map